import * as Models from "../../Models";
import { EventsObject } from "../../Interfaces/EventsObject";
import { Dictionary } from "sbtech-sports-data-api-client";
import { BaseDict } from "../../../blocks/PersonalizedHighlights/dict";
import { personalizationEvent } from "../../DataParser";
export class SportParser {

    public static getSport(
        sportId: string,
        sortId: string,
        sportName: string,
        eventIds: string[]): Models.Sport {
        return new Models.Sport(
            {
                id: sportId,
                sortId,
                eventIds,
                name: sportName
            });
    }

    public static getSports(personalizationData: Dictionary<personalizationEvent>, events: EventsObject
        , isEnableForYoutab: boolean, phrases: BaseDict) {

        let sports = {};

        for (var key in personalizationData) {
            if (personalizationData.hasOwnProperty(key) && key !== "0") {
                let eventsPerBranch = personalizationData[key];

                let validEventIds = this.getValidEventIds(eventsPerBranch, events);

                let firstEventId = validEventIds[0];

                if (this.isInvalidEvent(firstEventId, events)) { continue; }

                var sportSortId = 1 + eventsPerBranch.sportSortId;
                sports[key] = this.getSport(
                    key,
                    sportSortId.toString(),
                    events[firstEventId].sportName,
                    validEventIds);
            }
        }

        if (isEnableForYoutab) {
            let yourTabSortId = "0";
            let yourTabSportId = "0";
            sports[0] = this.getSport(
                yourTabSportId,
                yourTabSortId,
                phrases.YourTab,
                this.getValidEventIds(personalizationData[0], events));
        }

        return sports;
    }

    private static isInvalidEvent(firstEventId: string, events: EventsObject): boolean {
        return (firstEventId === undefined || events[firstEventId] === undefined);
    }

    private static getValidEventIds(eventsPerBranch: personalizationEvent, events: EventsObject): string[] {
        let validEventIds: string[] = [];

        Object.keys(eventsPerBranch.eventSorts).forEach(x => {
            if (!this.isInvalidEvent(x, events)) {
                validEventIds.push(x);
            }
        });

        return validEventIds;
    }
}
